<div class="p-3" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
    <form class="d-flex flex-column">
        <p class="field-label mb-1">Enter board name:</p>
        <input [(ngModel)]="boardName" name="name" type="text" class="form-control fs-14" />
        <div class="d-flex mt-3 ml-auto">
            <button (click)="CloseMenu()" class="btn transparent-button">Close</button>
            <button (click)="AddNewBoard()" class="btn light-blue-button ml-2">Save</button>
        </div>
    </form>
</div>